import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledEmailSettings = styled.div`
  margin-top: 25px;
  padding: 0 5px 30px;

  .email-settings-input-container {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-top: 15px;

    .email-settings-input-image {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      box-shadow: 0px 3.21px 6.27px 0px #1222433b;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
        display: block;
      }
    }

    .email-input-wrapper {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;

      input {
        background: ${colors.lightBlueGrayBackground};
        width: 100%;
        height: 30px;
        border: 0.5px solid #7e8aad80;
        border-radius: 33px;
        direction: ltr;
        padding: 0 40px 0 16px;
        color: ${colors.darkBlue};
        cursor: not-allowed;
        opacity: 0.7;

        &::placeholder {
          color: ${colors.blueGray};
        }

        &:focus-visible {
          outline: none;
        }

        &:disabled {
          background: #f5f5f5;
          color: #666;
          cursor: not-allowed;
        }
      }

      .email-at-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;

        img {
          width: 16px;
          height: auto;
        }
      }
    }
  }

  .email-success-message {
    color: ${colors.green};
    font-size: 10px;
    margin-top: 8px;
    text-align: center;
    font-weight: 500;
    animation: fadeInOut 5s ease-in-out;
    opacity: 0;
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0;
      transform: translateY(-5px);
    }
    10% {
      opacity: 1;
      transform: translateY(0);
    }
    90% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-5px);
    }
  }
`;
